export type IntegrationHealthStatus = 'HEALTHY' | 'UNHEALTHY' | 'UNKNOWN';

export interface IntegrationData {
  healthStatus?: IntegrationHealthStatus;
  errorCount?: number;
  lastError?: string;
  lastHealthCheck?: string;
}

export interface Integration {
  integrationId?: string;
  integrationType: IntegrationType;
  integrationProvider?: IntegrationProvider;
  status?: IntegrationStatus;
  credentials?: any;
  description?: string;
  link?: string;
  connectedByUserId?: string;
  connectedAt?: string;
  externalAccountEmail?: string;
  externalAccountId?: string;
  integrationData?: IntegrationData;
}

export enum IntegrationStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  NOT_ACTIVATED = 'NOT_ACTIVATED',
  GENERATING = 'GENERATING',
  GENERATED = 'GENERATED',
  FAILED = 'FAILED',
}

export enum IntegrationType {
  CALENDAR = 'CALENDAR',
  STORAGE = 'STORAGE',
  NOTES = 'NOTES',
  ISSUE_TRACKER = 'ISSUE_TRACKER',
  MESSAGING = 'MESSAGING',
  OTHER = 'OTHER',
}

export enum IntegrationProvider {
  GOOGLE = 'GOOGLE',
  SLACK = 'SLACK',
}

export interface getIntegrationRequest {
  getIntegrations: Integration[];
}

export interface createIntegrationRequest {
  createIntegration: Integration;
}

export interface deleteIntegrationRequest {
  deleteIntegration: {
    affected: number;
  };
}

export enum CalendarRepetition {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  YEARLY = 'YEARLY',
  NO_REPEAT = 'NO_REPEAT',
}
